import { PropsWithChildren } from 'react'

import styles from './panels.module.css'

interface Props {
  title: string
  testid?: string
}

const RfqModalPanel = ({
  title,
  testid,
  children
}: PropsWithChildren<Props>) => {
  return (
    <section className={styles.panel} data-testid={testid}>
      <header>{title}</header>
      {children}
    </section>
  )
}

export default RfqModalPanel
